import React from 'react';
import { Check } from '@phosphor-icons/react';

interface checkboxProps {
    checked: boolean;
    name?: string;
    label?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    required?: boolean;
    labelLeft?: boolean;
}

export default function Checkbox({
    checked,
    name,
    label,
    onChange,
    disabled = false,
    required = false,
    labelLeft = false,
}: checkboxProps) {
    return (
        <label
            className={`flex items-center space-x-3 ${
                disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer opacity-100'
            }`}
        >
            {label && labelLeft && <span>{label}</span>}
            <div className={`relative h-6 w-6`}>
                <input
                    required={required}
                    type="checkbox"
                    className="w-full h-full transition-all duration-300 bg-transparent border border-2 border-gray-300 rounded outline-none appearance-none cursor-pointer hover:border-primary checked:bg-primary checked:border-transparent"
                    checked={checked}
                    onChange={(e) => onChange(e)}
                    name={name}
                    disabled={disabled}
                />
                {checked && <Check className="text-input-checkboxColor absolute inset-0 h-5 w-5 m-auto" />}
            </div>
            {label && !labelLeft && <span>{label}</span>}
        </label>
    );
}
